<template>
    <b-modal
        size="md"
        v-model="modalShow"
        title="質問デッキ削除"
        @ok="handleOk"
        @cancel="close"
        @hidden="close">
        <form
            v-if="healthSurveyTemplate !== null"
            @submit.stop.prevent="onSubmit">
            <div class="text-center">下記の質問デッキを削除してもよろしいですか？</div>
            <div class="contentWrapper">
                <div class="contentItem mb-3">
                    <div>ID</div>
                    <div>{{ healthSurveyTemplate.id }}</div>
                </div>

                <div class="contentItem">
                    <div>タイトル</div>
                    <div>{{ healthSurveyTemplate.name }}</div>
                </div>
            </div>
        </form>

        <div slot="modal-footer">
            <button
                class="btn btn-danger float-right"
                :disabled="inProgress"
                @click="handleOk">
                削除
            </button>
            <button
                class="btn btn-yokumiru-gray float-right mr-2"
                :disabled="inProgress"
                @click="close">
                キャンセル
            </button>
        </div>
    </b-modal>
</template>

<script>
import constants from '../../../constants'
import YokumiruHelper from '../../../YokumiruHelper'

export default {
    data: function () {
        return {
            helper: YokumiruHelper,
            inProgress: false,
            modalShow: false,
            healthSurveyTemplate: null,
            errors: {},
        }
    },

    computed: {},

    created: function () {
        bus.$on('open-modal-admin-delete-health-survey-template', this.open)
    },

    beforeDestroy: function () {
        bus.$off('open-modal-admin-delete-health-survey-template')
    },

    methods: {
        /**
         * モーダル表示
         */
        open: function (healthSurveyTemplate) {
            this.healthSurveyTemplate = {...healthSurveyTemplate}
            this.modalShow = true
        },

        /**
         * モーダルを閉じる
         */
        close: function () {
            this.errors = {}
            this.modalShow = false
        },

        /**
         * 保存ボタン押下時
         * @param {object} e
         */
        handleOk: function (e) {
            e.preventDefault()
            this.onSubmit()
        },

        /**
         * 質問デッキ削除
         */
        onSubmit: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = constants.admin.health_survey_templates.endpoint.base

            await axios.delete(`${endpoint}/${this.healthSurveyTemplate.id}`)
                .then(() => {
                    bus.$emit('alert-success', '質問デッキを削除しました。')
                    bus.$emit('health-survey-template-deleted')
                    this.errors = {}
                    this.close()
                })
                .catch(({response}) => {
                    if (
                        response &&
                        response.hasOwnProperty('data') &&
                        response.data.hasOwnProperty('errors')
                    ) {
                        if (response.data.errors.hasOwnProperty('message')) {
                            bus.$emit('alert-danger', response.data.errors.message[0])
                        } else {
                            bus.$emit('alert-danger')
                            this.errors = response.data.errors
                        }
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                })

            this.inProgress = false
        },
    },
}
</script>

<style scoped lang="scss">
.contentWrapper {
    padding: 30px 15px;
}

.contentItem {
    flex-grow: 1;
    padding-bottom: 3px;
    border-bottom: 1px solid #989898;
}
</style>
